import Header from '@editorjs/header';

/**
 * Header with same rich inline rules as RichParagraph so H1–H6 keep colors and comment spans.
 */
export default class RichHeader extends Header {
  static get sanitize() {
    return {
      level: false,
      text: {
        br: true,
        a: { href: true, target: true, rel: true },
        b: true,
        strong: true,
        i: true,
        em: true,
        u: true,
        mark: true,
        code: true,
        span: { style: true, class: true, 'data-doc-comment-id': true },
        font: { color: true, face: true, size: true },
      },
    };
  }
}
